var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"signinView"},[_c('header-comp',{attrs:{"isSigninView":true}}),_c('div',{},[_c('signin-comp')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }